import classNames from 'classnames';
import * as React from 'react';
import { CnEllipsis } from '@/components/cn-ellipsis';
export const FormatText = (props) => {
    const { mode, value } = props;
    if (value && typeof value === 'object') {
        const { value: _value, text, link, toolTips, ...rest } = value;
        const style = rest;
        const content = (_value ?? text) || '- -';
        if (mode === 'simple') {
            return React.createElement(CnEllipsis, { style: style }, content);
        }
        return (React.createElement("span", { className: classNames({ 'cn-table-format-text-link': !!link }), style: style, onClick: () => link && window.open(link) }, content));
    }
    if (mode === 'simple') {
        return React.createElement(CnEllipsis, null, value || '- -');
    }
    return React.createElement(React.Fragment, null, value || '- -');
};
